import {styled} from 'external/material'
import ResourceTable from './ResourceTable'
import useProfile from 'hooks/profile'

const StyledHelp = styled('div')(helpStyles)

export default function Help () {
    const {project, settings} = useProfile()
    const {helpManualsByProject = {}} = settings
    const manual = helpManualsByProject[project] || helpManualsByProject['edusystem']
    return (
    <StyledHelp>
      <ResourceTable kind="manuals" resources={manual || []} />
    </StyledHelp>)
}


function helpStyles() {
  return {
    display: 'flex',
    padding: 20,
    flexDirection: 'column',
    marginTop: 10,
    flexGrow: 1,
  }
}